import 'url-search-params-polyfill';
// import "babel-polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";
//import 'date-time-format-timezone';
import React, { Suspense } from 'react'
import { createBrowserHistory } from 'history'
import { ConnectedRouter } from 'connected-react-router'
import { CookiesProvider } from 'react-cookie';
import routes from './routes/index'
import Header from './containers/header/verizonLogo';
import Footer from './containers/footer/footer';
export const history = createBrowserHistory();
import { connect } from 'react-redux';
import { InHomeUtils as InHomeUtilsnc } from './util/inhomeUtils';
import {store} from './index';
import SessionTimeout from './containers/fiosRetailTablet/Timeout';
import ErrorBoundary from '../src/ErrorBoundary';
import api from './service/apiService';
import { apiUrl } from './constants/apiUrl';
import ApplyLiveChatClass from './ApplyLiveChatClass'

const loadingImg = <div className="page-overlay active" >
    <div className="section-overlay">
        <div className="row section-loader vert-middle margin-vert-zero fluid-grid">
            <div className="column padding-vert-zero section-overlay-column">
                <div className="margin-top-small text-medium bold" role="alert" aria-live="assertive">
                    <div className="spin-loader">
                    </div>
                    <div className="loader-messgae">
                        Loading...
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>

class App extends React.Component {
    constructor(props) {
        super(props);
       
        
        InHomeUtilsnc.setHistory(props.history);
        if (window?.location?.href?.includes('fiosreferral')) {
            sessionStorage?.setItem('fiosReferralFlow', 'true');
            sessionStorage?.setItem('tempFeedbackHide', 'true');
        }
        
    }

    render(){
        window.isBestPlan = false;
        let isMvAppFlow = (this.props.signIn && this.props.signIn.isMvAppFlow) ? this.props.signIn.isMvAppFlow: false;
        let mobileViewEcFlow = window.location?.pathname?.indexOf('/change/') > -1 && window.innerWidth < 500;
        let mobileViewSuppFlow = window.location?.pathname?.indexOf('/change/supp') > -1 && window.innerWidth < 760;
        const Wrapper = window?.sessionStorage?.getItem("fiosReferralFlow") === "true" ? ErrorBoundary : React.Fragment;
        if(InHomeUtilsnc.getdeviceType() === "mobile"){
        window.Stickycheckout ="Y"}
        window.showProgressBar
        window.reskinCartChanges = (this.props.buildProductState && this.props.buildProductState.reskinCartFlag) ? "Y" : "N";
        window.addressQualificationType = this.props.buildProductState && this.props.buildProductState.offerIndicator ? this.props.buildProductState.offerIndicator : '';
        window.isBack = false;
        const isMonarchView = (window && window?.location && window?.location?.search) ? window?.location?.search?.includes('MN=Y') : false;
        let signInCookie;
        if(window.cookie){
            signInCookie  = window.cookie.split(";").filter(each => each.includes("islogin") || each.includes("loggedin=true"))[0]
        }
        window.isMnhBanner = ((this.props.buildProductState && this.props.buildProductState.internet && this.props.buildProductState.internet.mnhSignupIndicator !== "Y") || !signInCookie) ? true : false;
        window.acpIndicator = (this.props.buildProductState && this.props.buildProductState.isACPFlag) ? "Y" : "N";
        
        let chat_update = store.getState().loopQual;
        this.isReskin = this.props.buildProductState.isReskin && chat_update && chat_update.runtimeKey && chat_update.runtimeKey.EnableReskin === 'Y';
        const isMonarchFromAEM = chat_update && chat_update?.runtimeKey && (chat_update?.runtimeKey?.enableMidnite?.toUpperCase() === 'Y'|| chat_update?.runtimeKey?.ECenableMidnite?.toUpperCase() === 'Y' || chat_update?.runtimeKey?.enableMonarch?.toUpperCase() === 'Y');
        const channelLineUp = window.location.href;
        let CLUFlow = false;
        if(channelLineUp.includes("channellineup")){
            CLUFlow = true
        }

    return (
        <Wrapper>
            <Suspense fallback={loadingImg}>
                <ConnectedRouter history={this.props.history}>
    
                    <CookiesProvider>
    
                        <React.Fragment>
                            <SessionTimeout
                                time={45000}
                                history={this.props.history}
                            />
                            {(!isMvAppFlow && !CLUFlow && !mobileViewEcFlow) ||  mobileViewSuppFlow ? <Header isReskin={this.isReskin} isMonarchView={isMonarchView || isMonarchFromAEM || true} /> : null }
                            <React.Fragment>
                            <ApplyLiveChatClass />
                                {routes}                                
                            </React.Fragment>
                        </React.Fragment>
                        {((!isMvAppFlow && !this.isReskin ) && !CLUFlow)&& <Footer />}
    
                    </CookiesProvider>
    
                </ConnectedRouter>
            </Suspense>  
            </Wrapper>        

    

    )
        }
        componentDidMount(){
            
            try {
                const runtimeKeysLQ = window.sessionStorage.getItem('runtimeKeysLQ') ? JSON.parse(window.sessionStorage.getItem('runtimeKeysLQ')) : null;
                const enablePreflightReduction = runtimeKeysLQ?.EnablePreflightTimeReduction === 'Y';
                const pathName = window.location.pathname
                if ((pathName.includes("inhome/buildproducts") || pathName.includes("inhome/streamlineordering"))&& enablePreflightReduction) {
                  let url = apiUrl().getProduct + "/plans";
                  const request = {
                    isDummyReq: "Y"
                  };
                  api(url, "POST", request).then(response => {
                    console.log("Dummy Plans API response", response);
                  }).catch(error => {
                    console.error("Error in Dummy GetPlans API call", error);
                  });
                }
              } catch (ex) {
                console.error("Error in Dummy API call", ex);
              }
            /**adding gnav script inside the the react root file as it is not responding to soft load */
            if(window.location.href.includes("/inhome/change")){
            var host = window.location.host;
            var gnavsrc = '';
            if (host === "www.verizon.com" || host === "wwwordering-prod-east-yz.vpc.verizon.com") {
                gnavsrc = 'https://www.verizon.com/etc/designs/vzwcom/gnav20/personal.js';
            } else {
                gnavsrc = 'https://vzwqa2.sdc.vzwcorp.com/etc/designs/vzwcom/gnav20/personal.js';
            }
            const script = document.createElement("script");
            script.src = gnavsrc
            document.body.appendChild(script);
            //css
            var gnavcsssrc = '';
            if (window.location.host === "www.verizon.com" || window.location.host === "wwwordering-prod-east-yz.vpc.verizon.com") {
                gnavcsssrc = "https://www.verizon.com/etc/designs/vzwcom/gnav20/core.css";
            } else {
                gnavcsssrc = "https://vzwqa2.sdc.vzwcorp.com/etc/designs/vzwcom/gnav20/core.css";
            }
            const link = document.createElement('link');
            link.href = gnavcsssrc
            document.body.appendChild(link);
        }
       
        }
}

const mapStateToProps = (state) => {
    return {
        signIn: state.signIn,
        buildProductState : state.buildProduct
    }
}

export default connect(
    mapStateToProps,
)(App);